export const VARIANCE_THRESHOLD_COOKIE_NAME = 'varianceThreshold';
export const DISPLAY_VARIANCE_THRESHOLD_COOKIE_NAME = 'displayVarianceThreshold';
export const VARIANCE_THRESHOLD_TYPE_COOKIE_NAME = 'varianceThresholdType';
export const VARIANCE_THRESHOLD_DISPLAY_FORMAT_COOKIE_NAME = 'varianceThresholdDisplayFormat';
export const SHOW_ONLY_EXCEEDING_ROWS_COOKIE_NAME = 'showOnlyExceedingRows';
export const CALCULATION_REPORT_LIST_NAME = 'calculationReportList';
export const OPENED_REPORTS_NAME = 'openedReports';
/** Session-scoped Pillar 2 "submitted" flag per report (keyed with env/user/enterprise in app code). */
export const PILLAR2_SUBMITTED_REPORT_PREFIX = 'pillar2SubmittedReport';
/** Session-scoped list of fields hidden via the ReportsTable Column Chooser. */
export const REPORTS_TABLE_HIDDEN_COLUMNS_NAME = 'reportsTableHiddenColumns';
